<div [ngClass]="customClass">
  <span class="p-input-icon-right mt-2 mb-1">
    <p-knob [ngModel]="value" valueTemplate="{value}%" [readonly]="true" [size]="size"  [strokeWidth]="strokeWidth"
            [pTooltip]="value+'%'" [valueColor]="valueColor(value)" [rangeColor]="'SlateGray'" [min]="0" [max]="100"></p-knob>
  </span>
    <div class="text-sm font-bold mt-">{{ label }}</div>
</div>

